import React from 'react';
import { useDaresFilter } from 'root/src/client/web/record/DropEvent/DaresFilter/DaresFilterProvider';
import { ArrowDropDownSharp } from '@mui/icons-material';
import { BaseTooltip, BaseTooltipContent } from 'root/src/client/v2/common/components/BaseTooltip/BaseTooltip';
import { dropDareDifficultyEstimatedTime } from 'root/src/shared/constants/dropEvent';
import { DaresFilterCheckbox } from 'root/src/client/web/record/DropEvent/DaresFilter/DaresFilterCheckbox';
import * as Accordion from '@radix-ui/react-accordion';
import { DROPS_ANALYTIC_EVENTS } from 'root/src/shared/drops/drops.analytics';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
export const LevelFilter = React.memo(() => {
    const { state, options, onFilterChange } = useDaresFilter();
    const handleValueChange = (option) => {
        analyticsSendItem(DROPS_ANALYTIC_EVENTS.DROP_DARE_FILTERS, 'difficulty');
        if (state.levels.includes(option)) {
            onFilterChange(Object.assign(Object.assign({}, state), { levels: state.levels.filter(item => item !== option) }));
        }
        else {
            onFilterChange(Object.assign(Object.assign({}, state), { levels: [...state.levels, option] }));
        }
    };
    return (<Accordion.Root className="AccordionRoot" type="single" collapsible defaultValue="level">
			<Accordion.Item className="AccordionItem overflow-x-hidden" value="level">
				<Accordion.AccordionTrigger className="uppercase flex py-2 justify-between group w-full">
					<span className="flex w-full">
						Dare difficulty
					</span>
					<ArrowDropDownSharp className="!transition !duration-200 -rotate-90 group-data-[state=open]:rotate-0"/>
				</Accordion.AccordionTrigger>
				<Accordion.AccordionContent className="AccordionContent">
					<ul className="flex flex-col gap-2 p-4">
						{options.levels.map((option) => {
            const isSelected = state.levels.includes(option.value);
            return (<li key={option.value} className="flex flex-initial font-medium font-mono justify-between items-center gap-4">
									<BaseTooltip tooltip={(<BaseTooltipContent>
											{dropDareDifficultyEstimatedTime[option.value]}
										</BaseTooltipContent>)}>
										<label htmlFor={`level-${option.value}`} className="flex select-none gap-3 items-center">
											{option.label}
										</label>
									</BaseTooltip>
									<DaresFilterCheckbox id={`level-${option.value}`} onCheckedChange={() => handleValueChange(option.value)} checked={isSelected}/>
								</li>);
        })}
					</ul>
				</Accordion.AccordionContent>
			</Accordion.Item>
		</Accordion.Root>);
});
